import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 1vw;
  z-index: 1;
`

export const HeaderText = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 1.4vw;
  font-weight: 700;
  margin-top: 20px;
  margin-bottom: 0;
  margin-left: 20px;
`

export const InputRowDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 57vw;
  margin-top: 3vh;
`
export const ScrollDiv = styled.div`
  overflow-y: auto;
  height: 50vh;
`
export const InputDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 8px; 
  white-space: nowrap; 

  p {
    margin: 0;
    font-size: 0.9vw;
    font-weight: bold;
  }

  .redBorder {
    border: #ff0000 1px solid;
  }
`

export const InputLabel = styled.label`
  display: block;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 0.9vw;
  margin-left: 1.5vw;
`

export const Input = styled.input`
  width: 15.5vw;
  height: 5.3vh;
  background-color: #ebebeb;
  border: 0;
  border-radius: 2vw;
  margin-top: 0.8vh;
  margin-left: 1vw;
  padding-left: 1vw;
  padding-right: 1vw;

  :focus {
    outline: 0;
  }
`

export const ButtonsDiv = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  margin-left: 32vw;
  margin-top: 5vh;

  a {
    text-decoration: none;
  }
`

export const EditButtonDiv = styled.div<{ disabled?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6vw;
  height: 5.8vh;
  background-color: #fff;
  color: #0090d3;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  margin-left: 1vw;
  border: 2px #0090d3 solid;
  border-radius: 3vw;
  cursor: pointer;

  ${(props) =>
    props.disabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  `}
`

export const ButtonImage = styled.img`
  width: 1.5vw;
`

export const ButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
`

export const MovimentButtonDiv = styled.div<{ disabled?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 11vw;
  height: 5.8vh;
  background-color: #fff;
  color: #0090d3;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  margin-left: 1vw;
  border: 2px #0090d3 solid;
  border-radius: 3vw;
  cursor: pointer;

  ${(props) =>
    props.disabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  `}
`
export const MovimentButtonImage = styled.img`
  width: 1vw;
  margin-right: 0.2vw;
`

export const ButtonImageCertificate = styled.img`
  width: 1vw;
  margin-right: 0.2vw;
`

export const CertificateButtonDiv = styled.div<{ disabled?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10vw;
  height: 5.8vh;
  background-color: ${({ disabled }) => (disabled ? '#ebebeb' : '#fff')};
  color: ${({ disabled }) => (disabled ? '#c4c4c4' : '#0090D3')};
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  margin-left: 1vw;
  border: 2px solid ${({ disabled }) => (disabled ? '#c4c4c4' : '#0090D3')};
  border-radius: 3vw;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 1 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  img {
    filter: ${({ disabled }) =>
      disabled ? 'grayscale(100%) brightness(0.7)' : 'none'};
  }
`

export const DisabledButtonDiv = styled.div`
  display: flex;
  align-items: center;
  width: 10vw;
  height: 5.8vh;
  background-color: #ebebeb;
  color: #c4c4c4;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  margin-left: 1vw;
  border-radius: 3vw;
  cursor: not-allowed;
`

export const DisabledButtonImage = styled.img`
  width: 0.9vw;
`

export const DisabledButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
`

export const ButtonDiv = styled.div`
  display: flex;
  align-items: center;
  width: 10vw;
  height: 5.8vh;
  background-color: #fff;
  color: #0090d3;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  margin-left: 1vw;
  border: 2px #0090d3 solid;
  border-radius: 3vw;
  cursor: pointer;

`

export const CloseDiv = styled.div`
  position: absolute;
  top: 4%;
  left: 94%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2vw;
  cursor: pointer;
  width: 2.5vw;
  height: 2.5vw;

  :hover {
    background-color: #f4f4f4;
  }
`

export const CloseImg = styled.img`
  width: 0.8vw;
`
export const SwitchButton = styled.button`
  background-color: #0090d3; 
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;

  &:hover {
    background-color: #016ea0ff;
  }
`
